<div class="component-container">
  <app-review-section
    #oldMeterDataSection
    [title]="
      showData ? ('facilities-data.old-meter-data-title' | translate) : ('basic-profile.jurisdiction.meter-data.meter_data' | translate)
    "
    [tooltip]="'tooltips.facilities-data.old-meter-data' | translate"
    [showTooltip]="infoBubblesData?.showOldMeterDataHeaderInfo"
    [sectionId]="oldMeterDataSectionIdentifier"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView">
    <form *ngIf="meterFG" [formGroup]="meterFG">
      <div *ngFor="let meter of metersObj.controls; let i = index" formArrayName="meters">
        <div [formGroupName]="i" class="ui-g meter-section form-font-size">
          <div class="ui-g-12">
            <div class="ui-g form-rows relative-position">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label
                    for="old-meter-number-{{ i }}"
                    class="ui-g-5 field-label text-right-align"
                    [ngClass]="{ required: isMeterNumberRequired }">
                    <ng-container *ngIf="showData">{{ 'facilities-data.form-fields.meter-number' | translate }}</ng-container>
                    <ng-container *ngIf="!showData">{{ 'facilities-data.form-fields.meter-number-old-meter' | translate }}</ng-container>
                  </label>
                  <input
                    id="old-meter-number-{{ i }}"
                    pInputText
                    formControlName="meterNumber"
                    type="text"
                    [readOnly]="!oldMeterDataSection.isDataEditable"
                    [required]="isMeterNumberRequired" />
                </div>
                <div *ngIf="!hideOldMeterAction" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <p-radioButton
                    class="alignment-radio-buttons"
                    formControlName="meterAction"
                    label="{{ 'facilities-data.form-fields.meter-action-remove' | translate }}"
                    name="meter-action-{{ i }}"
                    value="removed"></p-radioButton>
                  <p-radioButton
                    class="alignment-radio-buttons"
                    formControlName="meterAction"
                    label="{{ 'facilities-data.form-fields.meter-action-consolidate' | translate }}"
                    name="meter-action-{{ i }}"
                    value="consolidation"></p-radioButton>
                </div>
              </div>

              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="meter.get('meterReading')">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                  <label for="old-meter-reading-{{ i }}" class="ui-g-5 field-label text-right-align">
                    {{ 'facilities-data.form-fields.meter-reading' | translate }}
                  </label>
                  <input
                    id="old-meter-reading-{{ i }}"
                    pInputText
                    formControlName="meterReading"
                    [appNumber]="true"
                    [readOnly]="!oldMeterDataSection.isDataEditable" />
                </div>
              </div>

              <div
                class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
                *ngIf="meter.get('meterDocumentName') && oldMeterDataSection.isDataEditable">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 field-rows">
                  <label for="old-meter-image-{{ i }}" class="ui-g-5 field-label text-right-align">
                    {{ 'facilities-data.form-fields.meter-image' | translate }}
                  </label>
                  <input
                    pInputText
                    id="old-meter-image-{{ i }}"
                    formControlName="meterDocumentName"
                    type="text"
                    [readOnly]="!oldMeterDataSection.isDataEditable" />
                </div>
                <p-fileUpload
                  #meterImageUploader
                  mode="basic"
                  accept="image/*"
                  [disabled]="!oldMeterDataSection.isDataEditable"
                  class="file-upload-button ui-g-3"
                  id="meter-data-upload-{{ i }}"
                  (onSelect)="onImageUpload($event, meterImageUploader, i)"
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"></p-fileUpload>
              </div>
              <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 field-rows file-name-section" *ngIf="getFileName(i)">
                <a href="javascript:void(0)" (click)="downloadDocument(i)">{{ getFileName(i) }}</a>
                <i class="pi pi-trash pointer-cursor" (click)="removeFile(i)" *ngIf="oldMeterDataSection.isDataEditable"></i>
              </div>
              <div *ngIf="oldMeterDataSection.isDataEditable && metersObj.controls.length > 1" class="top-right-position">
                <div (click)="removeMeter(i)" class="pi pi-trash pointer-cursor"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div *ngIf="oldMeterDataSection.isDataEditable && !hideOldMeterAction" class="ui-g-12 margin-align add-meter-btn">
      <span>
        <i (click)="addMeter(true)" class="pi pi-plus plus-icon" id="base-data-add-facility" tabindex="0" appEnterClick></i>
        <label class="add-meter-txt form-font-size" for="base-data-add-facility">
          {{ 'basic-profile.jurisdiction.meter-data.add_meter' | translate }}
        </label>
      </span>
      <ng-container>
        <span>
          <button [disabled]="!count || count < 0" (click)="addMultipleMeterData()" class="pi pi-copy copy-icon"></button>
          <label class="add-meter-txt form-font-size" for="base-data-add-facility">
            {{ 'basic-profile.jurisdiction.meter-data.copy_counter' | translate }}
          </label>
          <input
            type="number"
            class="copy-counter"
            (keyup)="counter($event)"
            name="count"
            value=""
            [(ngModel)]="count"
            [ngModelOptions]="{ standalone: true }" />
          <i class="pi pi-caret-up caret up" (click)="caretUp()"></i>
          <i class="pi pi-caret-down caret down" (click)="caretDown()"></i>
        </span>
      </ng-container>
    </div>
  </app-review-section>
</div>
